import React from 'react'
import './Button.scss'
import {Link} from 'gatsby'

export default function Button({mail, title, url, target, color, id, label, onClick = () => null}) {
	if(mail) {
		return(
			<a onClick={onClick} id={id} href={mail} target={target} className={`Button ${color}`} aria-labelledby={label}>
				<span>{title}</span>
			</a>
		)
	}
	return(
		<Link onClick={onClick} id={id} to={url} target={target} className={`Button ${color}`} aria-labelledby={label}>
			<span>{title}</span>
		</Link>
	)
}